import {
    referenceLoadAudience,
    referenceLoadEditorAudience,
    referenceLoadEditorData,
} from '../../store/actions/references'
import {
    scheduleCheckOccupancy,
    scheduleDeleteLesson,
    scheduleLoad,
    scheduleLoadForClasses,
    scheduleSaveLesson,
} from '../../store/actions/schedule'
import { scheduleActions } from '../../store/slices/schedule'
import { editSchedulePageActions } from '../../store/slices/editSchedulePage'

export const editScheduleEffectsActions = {
    referenceLoadEditorData,
    referenceLoadEditorAudience,
    scheduleLoad,
    scheduleLoadForClasses,
    scheduleCheckOccupancy,
    resetOccupancy: scheduleActions.resetOccupancy,
    setSelectedGroupId: editSchedulePageActions.setSelectedGroupId,
    setSelectedTeacherId: editSchedulePageActions.setSelectedTeacherId,
}

export const editScheduleFiltersActions = {
    resetSchedule: scheduleActions.resetSchedule,
    referenceLoadAudience,
    setDateRange: editSchedulePageActions.setDateRange,
    clearDateFilter: editSchedulePageActions.clearDateFilter,
    setViewMode: editSchedulePageActions.setViewMode,
    setSelectedGroupId: editSchedulePageActions.setSelectedGroupId,
    setSelectedTeacherId: editSchedulePageActions.setSelectedTeacherId,
    setSelectedBuildId: editSchedulePageActions.setSelectedBuildId,
    setSelectedRoomId: editSchedulePageActions.setSelectedRoomId,
    setSelectedClassTypeId: editSchedulePageActions.setSelectedClassTypeId,
    setSelectedSubjectId: editSchedulePageActions.setSelectedSubjectId,
    resetFilters: editSchedulePageActions.resetFilters,
    toggleShowMoreOptions: editSchedulePageActions.toggleShowMoreOptions,
    resetEditor: editSchedulePageActions.resetEditor,
    setPendingAction: editSchedulePageActions.setPendingAction,
}

export const editScheduleListActions = {
    setPagination: editSchedulePageActions.setPagination,
    openEditor: editSchedulePageActions.openEditor,
    resetEditor: editSchedulePageActions.resetEditor,
    setPendingAction: editSchedulePageActions.setPendingAction,
    setShowDeleteModal: editSchedulePageActions.setShowDeleteModal,
    deleteLesson: scheduleDeleteLesson,
}

export const editScheduleEditorActions = {
    updateFormField: editSchedulePageActions.updateFormField,
    updateFormFields: editSchedulePageActions.updateFormFields,
    resetEditor: editSchedulePageActions.resetEditor,
    setPendingAction: editSchedulePageActions.setPendingAction,
    setShowCloseEditorModal: editSchedulePageActions.setShowCloseEditorModal,
    saveLesson: scheduleSaveLesson,
    openEditor: editSchedulePageActions.openEditor,
}

export const editScheduleModalsActions = {
    setShowDeleteModal: editSchedulePageActions.setShowDeleteModal,
    setShowCloseEditorModal: editSchedulePageActions.setShowCloseEditorModal,
    deleteLesson: scheduleDeleteLesson,
    resetEditor: editSchedulePageActions.resetEditor,
}

export const editScheduleToolbarActions = {
    openEditor: editSchedulePageActions.openEditor,
    setPendingAction: editSchedulePageActions.setPendingAction,
}
